const hostname = window.location.hostname

export default hostname === 'localhost' ? 'http://localhost:3160' : 'https://api.thunderchild.es';